import { render, staticRenderFns } from "./SiteMonitor.vue?vue&type=template&id=bce28242&scoped=true"
import script from "./SiteMonitor.vue?vue&type=script&lang=ts"
export * from "./SiteMonitor.vue?vue&type=script&lang=ts"
import style0 from "./SiteMonitor.vue?vue&type=style&index=0&id=bce28242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce28242",
  null
  
)

export default component.exports